import { render } from "./AccordionLink.vue?vue&type=template&id=e285ab1a"
import script from "./AccordionLink.vue?vue&type=script&lang=js"
export * from "./AccordionLink.vue?vue&type=script&lang=js"

import "./AccordionLink.vue?vue&type=style&index=0&id=e285ab1a&lang=scss"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__